export const ADD_PENSIONS = 'ADD_PENSIONS'
export const ADD_PENSION = 'ADD_PENSION'
export const ADD_PENSION_TYPE_ENUM = 'ADD_PENSION_TYPE_ENUM'
